/* tslint:disable */
/* eslint-disable */
/**
 * RakuLogi API
 * RakuLogi の API ドキュメント
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RequestGetSyncItemsStautsRequest
 */
export interface RequestGetSyncItemsStautsRequest {
    /**
     * 
     * @type {number}
     * @memberof RequestGetSyncItemsStautsRequest
     */
    tenantId?: number;
    /**
     * 
     * @type {number}
     * @memberof RequestGetSyncItemsStautsRequest
     */
    userId?: number;
}

/**
 * Check if a given object implements the RequestGetSyncItemsStautsRequest interface.
 */
export function instanceOfRequestGetSyncItemsStautsRequest(value: object): value is RequestGetSyncItemsStautsRequest {
    return true;
}

export function RequestGetSyncItemsStautsRequestFromJSON(json: any): RequestGetSyncItemsStautsRequest {
    return RequestGetSyncItemsStautsRequestFromJSONTyped(json, false);
}

export function RequestGetSyncItemsStautsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RequestGetSyncItemsStautsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'tenantId': json['tenant_id'] == null ? undefined : json['tenant_id'],
        'userId': json['user_id'] == null ? undefined : json['user_id'],
    };
}

export function RequestGetSyncItemsStautsRequestToJSON(json: any): RequestGetSyncItemsStautsRequest {
    return RequestGetSyncItemsStautsRequestToJSONTyped(json, false);
}

export function RequestGetSyncItemsStautsRequestToJSONTyped(value?: RequestGetSyncItemsStautsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'tenant_id': value['tenantId'],
        'user_id': value['userId'],
    };
}

